const inputsClassnames = {
  root: "w-full",
  label:
    "text-primary-white font-bold w-full font-inter font-medium text-center text-16 pb-2",
  input:
    "bg-primary-default text-primary-light-text border-primary-lighter data-[error=true]:border-red-500 focus:border-2 rounded-lg font-inter font-normal",
  dropdown: "bg-primary-lighter text-primary-light-text border-primary-lighter",
  option: "hover:gradient-blue-purple",
};

export default inputsClassnames;
